import React from 'react'
import {
  FlexGrid,
  Image,
  Typography,
  Box,
  OrderedList,
  useViewport
} from '@telus-uds/components-web'

import { object } from 'prop-types'
import useTranslate from '../../../hooks/useTranslate'
import { LogoContainer } from '../CartItem/styles'
import { getImageUrlAndAltText } from '../CartItem/utils'
import GiftLabel from './GiftLabel'
import { GiftContentContainer, GiftLabelContainer } from './styles'

const MAX_WIDTH = 128
const MAX_HEIGHT = 128

const GiftDisplay = ({ gift }) => {
  const translate = useTranslate()
  const { imageUrl, imageAlt } = getImageUrlAndAltText(gift)
  const viewport = useViewport()
  const isMobile = ['xs', 'sm'].includes(viewport)

  return (
    <FlexGrid.Row verticalAlign="middle" testID={`gift-details-${gift.id}`}>
      <FlexGrid.Col xs={12} md={2} justifyContent={isMobile ? 'flex-start' : 'center'}>
        <LogoContainer>
          <Image
            width={MAX_WIDTH}
            height={MAX_HEIGHT}
            src={`${imageUrl}?w=${MAX_WIDTH}&h=${MAX_HEIGHT}`}
            alt={imageAlt}
          />
        </LogoContainer>
      </FlexGrid.Col>
      <FlexGrid.Col xs={12} md={10}>
        <GiftContentContainer isMobile={isMobile}>
          <FlexGrid.Row>
            <FlexGrid.Col flex xs={12} md={10} horizontalAlign="left">
              <Box bottom={2}>
                <Typography variant={{ size: 'small' }}>{translate('gift')}</Typography>
                <Typography testID="gift-name" variant={isMobile ? { size: 'h3' } : { size: 'h2' }}>
                  {gift.productOffering.displayName}
                </Typography>
              </Box>
            </FlexGrid.Col>
            <FlexGrid.Col flex xs={0} md={2} horizontalAlign="right">
              <GiftLabelContainer isMobile={isMobile}>
                <GiftLabel size="large" />
              </GiftLabelContainer>
            </FlexGrid.Col>
          </FlexGrid.Row>
          <FlexGrid.Row>
            <FlexGrid.Col xs={12} horizontalAlign="right">
              <Box bottom={{ xs: 3, md: 0 }}>
                <OrderedList>
                  {gift.productOffering.characteristics.map((characteristic) => (
                    <OrderedList.Item
                      testID={`gift-characteristic-${characteristic.name}`}
                      key={characteristic.name}
                    >
                      {characteristic.value}
                    </OrderedList.Item>
                  ))}
                </OrderedList>
              </Box>
            </FlexGrid.Col>
          </FlexGrid.Row>
        </GiftContentContainer>
      </FlexGrid.Col>
    </FlexGrid.Row>
  )
}

GiftDisplay.propTypes = {
  gift: object.isRequired
}

export default GiftDisplay
